import { useAppSelector } from 'reduxTyped'

import { IBlock } from 'common/builder/blocks/blockInterfaces'
import * as entitySelectors from 'common/builder/selectors/builder/entitySelectors'

export const useBlock = <T extends IBlock = IBlock>(
  builderId: string,
  blockId: string,
): { block: T } => {
  const block = useAppSelector((state) =>
    entitySelectors.getBlockById(state, builderId, blockId),
  ) as T

  return {
    block,
  }
}
